export const RequestServices = {
    allPokemon: {
        limit: ""
    }
};